/**
 * Distinct, order-preserving, trimmed non-empty values of `column` across `rows`.
 *
 * This is the "which components are in this file" derivation that drives
 * parameter discovery. Shared by the Upload, Map Columns, Review, and Results
 * screens so they can't drift apart. Returns an empty list when `column` is
 * empty (no component column selected/detected yet).
 */
export function distinctComponentNames(
  rows: Record<string, string>[],
  column: string,
): string[] {
  if (!column) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const row of rows) {
    const value = (row[column] ?? "").trim();
    if (value && !seen.has(value)) {
      seen.add(value);
      out.push(value);
    }
  }
  return out;
}
